import { render } from "./receiptlist.vue?vue&type=template&id=28397e67"
import script from "./receiptlist.vue?vue&type=script&lang=js"
export * from "./receiptlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__